import { toast } from 'react-toastify';

export const CustomToast = {
    success: (message: string) => {
        toast.success(message, {
            closeButton: false,
            style: {
                backgroundColor: '#3A50FF',
                color: 'white',
                width: '25vw',
                minHeight: '44px',
            },
        });
    },
    error: (message: string) => {
        toast.error(message, {
            closeButton: false,
            style: {
                backgroundColor: '#FE495F',
                color: 'white',
                width: '25vw',
                minHeight: '44px',
            },
        });
    },
};
